export default "__VITE_ASSET__BvOyMZVI__"